import * as Yup from 'yup';

export const validationsSignIn = Yup.object({
    username: Yup.string()
        .required('El usuario es obligatorio')
        .email('El formato del usuario es incorrecto')
        .test('Validate Email', 'El correo es inválido', (value) => {
            const re =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(value).toLowerCase());
        }),
    password: Yup.string()
        .required('La calve es obligatorio')
        .min(8, 'La contraseña debe tener al menos 8 caracteres'),
    channel: Yup.string().required('El canal es obligatorio'),
});

export const valuesSignIn = {
    username: '',
    password: '',
    channel: '',
};

export const valuesChat = {
    type_identification: '',
    name: '',
    surname: '',
    email: '',
    identification: '',
    cell: '',
    type: '',
};
